import type { GeoFeature } from "../types/GeoFeature.js";
import type { GeoArVisibilityState } from "../types/GeoArState.js";

export interface ConfidenceInput {
  gpsAccuracy: number;
  headingAccuracy: number | null;
  relativeAngle: number | null;
  fieldOfView: number;
  feature: GeoFeature;
  visibilityState: GeoArVisibilityState;
  gpsAccuracyThreshold: number;
  headingAccuracyThreshold: number;
}

function clamp01(value: number): number {
  return Math.min(1, Math.max(0, value));
}

export function calculateConfidence(input: ConfidenceInput): number {
  if (input.visibilityState === "NO_INFORMATION") {
    return 0;
  }

  const gpsScore = clamp01(1 - input.gpsAccuracy / Math.max(input.gpsAccuracyThreshold * 2, 1));

  const headingScore =
    input.headingAccuracy === null
      ? 0
      : clamp01(
          1 -
            input.headingAccuracy /
              Math.max(input.headingAccuracyThreshold * 2, 1),
        );

  const angularScore =
    input.relativeAngle === null
      ? 0
      : clamp01(1 - Math.abs(input.relativeAngle) / Math.max(input.fieldOfView / 2, 1));

  const verificationScore = input.feature.verified ? 1 : 0.6;

  const score =
    gpsScore * 0.3 +
    headingScore * 0.3 +
    angularScore * 0.25 +
    verificationScore * 0.15;

  return Math.round(clamp01(score) * 1000) / 1000;
}
